var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import XCircleSvg from './x-circle.icon.svg';
export const XCircleIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: XCircleSvg }));
_react_refresh_temp_1 = XCircleIcon;
$RefreshReg$(_react_refresh_temp_1, "XCircleIcon");
